import { render } from "./ClinicalExamForm.vue?vue&type=template&id=a86bcca0&scoped=true"
import script from "./ClinicalExamForm.vue?vue&type=script&lang=js"
export * from "./ClinicalExamForm.vue?vue&type=script&lang=js"

import "./ClinicalExamForm.vue?vue&type=style&index=0&id=a86bcca0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a86bcca0"]])

export default __exports__